export default "__VITE_ASSET__BewnFVpc__"